/**
 * PlotViewerPanel — view provenance-tagged matplotlib plots.
 *
 * Displays static plot images from the Python SDK with ARQO provenance
 * tags. AG Grid handles interactive exploration; this panel handles
 * the static provenance images.
 */

import { Box, Text } from "@radix-ui/themes";
import { PlotViewer } from "../plots/PlotViewer";

export default function PlotViewerPanel() {
  return (
    <Box
      p="3"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <PlotViewer />
      <Text size="1" color="gray" mt="2">
        Select an artifact to view its plot
      </Text>
    </Box>
  );
}
